export default {
  SET_ONBOARDING_DETAILS: "SET_ONBOARDING_DETAILS",
  SET_ONBOARDING_FETCH_IN_PROGRESS: "SET_ONBOARDING_FETCH_IN_PROGRESS",
  SET_ONBOARDING_FETCH_ERROR: "SET_ONBOARDING_FETCH_ERROR",
};
